<template>
    <div class="main-wrapper">
        <layout-header />

        <div>
            <div class="overflow-hidden bg-light bg-cover bg-no-repeat pb-md-5 pb-4 rounded-none position-relative w-100 features-img"
                :style="'padding-top: 120px;background-position:center;background-image: url('+require('@/assets/img/bg-hero.jpg')+');'">
                <div class="container px-4 pt-3 pt-lg-5 mx-auto position-relative" style="z-index: 1">
                    <figure class="bg-white rounded-xl p-2 d-inline-block mb-2" style="max-width: 100px" >
                        <img :src="previewUrl || defaultLogo" class="w-100 h-auto">
                    </figure>
                    <h1 class="font-weight-bold text-white">{{ team?.name }}</h1>
                    <address class="my-2">
                        <p class="text-sm text-white">{{ team?.delegation }}</p>
                    </address>
                </div>
            </div>
            <div class="d-flex container justify-content-between align-items-center sticky-top border-bottom mb-3 bg-white px-2 pt-3" style="top: 86px">
                <ul class="nav nav-tabs nav-tabs-bottom nav-justified">
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: activeSection === 'details' }"
                            @click.prevent="scrollTo('details')">Détails</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: activeSection === 'players' }"
                            @click.prevent="scrollTo('players')">Joueurs</a>
                    </li>
                    <!-- <li class="nav-item">
                        <a class="nav-link" style="width: max-content !important;" :class="{ active: activeSection === 'about' }"
                            @click.prevent="scrollTo('about')">À Propos</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: activeSection === 'photos' }"
                            @click.prevent="scrollTo('photos')">Photos</a>
                    </li> -->
                </ul>
            </div>
            <div class="container mb-5 pb-5">
                <section id="details" class="mb-3" style="min-height: 120px;">
                    <div class="row">
                        <div class="col-6">
                            <div class="form-group card-label h-100 mb-3">
                                <label>Créée le</label>
                                <span class="input form-control">{{ formatDateTime(team.created_at).date }}</span>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group card-label h-100 mb-3">
                                <label>Délégation</label>
                                <span class="input form-control">{{team.delegation}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <div class="form-group card-label h-100 mb-3">
                                <label>Format</label>
                                <span class="input form-control">{{team.format}}</span>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group card-label h-100 mb-3">
                                <label>Formation</label>
                                <span class="input form-control">{{team.formation}}</span>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="players" class="mb-5" style="min-height: 400px;">
                    <h3><b>Joueurs</b></h3>
                    <div v-if="teamMembers.length !== 0" class="table-responsive text-xs py-2 px-0">
                        <table class="table table-hover table-center mb-0">
                            <thead class="bg-light">
                                <tr>
                                    <th>Nom Joueur</th>
                                    <!-- <th>Role</th> -->
                                    <!-- <th>Position</th> -->
                                    <th>Poste(s) Préférée(s)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in teamMembers" :key="item.id">
                                    <td>
                                        <span>
                                            {{ item.player.name }}
                                            <b>
                                                {{ (item.player.id === team.owner_id) ? ' (C)' : '' }}
                                            </b>
                                        </span>
                                    </td>
                                    <!-- <td>{{ membershipRoles[item.role] }}</td> -->
                                    <!-- <td>
                                        <span v-if="item.lineup_position" class="badge p-2 ml-1" :class="playerPositions[item.lineup_position]['class']">
                                            {{ playerPositions[item.lineup_position]['abbr'] }}
                                        </span>
                                    </td> -->
                                    <td>
                                        <span v-for="position in item.player.position.split(',').map(p => p.trim())" class="badge p-2 ml-1" :class="playerPositions[position] ? playerPositions[position]['class'] : ''">
                                            {{ playerPositions[position] ? playerPositions[position]['abbr'] : position }}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>
            </div>
        </div>

        <layout-footer />
    </div>
</template>
<style lang="css">
.nav-tabs.nav-justified > li > a {
    cursor: pointer;
}
</style>
<script>
import moment from "moment";
import 'moment/locale/fr';
import { api } from "@/store";
import defaultLogoPath from '@/assets/img/photo.png'

export default {
    computed: {
    },
    props: ['id'],
    data() {
        return {
            sections: [
                { id: 'details', label: 'Details' },
                { id: 'players', label: 'Joueurs' },
            ],
            previewUrl: null,
            activeSection: '',
            defaultLogo: defaultLogoPath,
            player: {},
            team: {},
            teamMembers: [],
            membershipRoles: {
                'captain': 'Capitaine',
                'starting': 'Titulaire',
                'substitute': 'Remplaçant'
            },
            playerPositions: {
                'goalkeeper': {'abbr': 'G', 'class': 'bg-warning-light'},
                'defender': {'abbr': 'DF', 'class': 'bg-primary-light'},
                'midfielder': {'abbr': 'ML', 'class': 'bg-success-light'},
                'forward': {'abbr': 'AT', 'class': 'bg-danger-light'}
            },
        }
    },
    created() {
        this.getTeam()
    },
    methods: {
        getTeam() {
            api.get('/teams/'+this.id)
                .then(response => {
                    const result = response.data
                    this.team = result
                    this.previewUrl = this.team.logo
                    this.teamMembers = this.team.memberships.filter(membership => membership.status == 'accepted')
                        .sort((a, b) => a.role.localeCompare(b.role))
                })
        },
        formatDateTime(datetimeString) {
            if (!datetimeString) return "";
            const date = new Date(datetimeString);
            const formattedDate = date.toISOString().split("T")[0];
            // Extract local hours and minutes
            const hours = date.getHours().toString().padStart(2, "0");
            const minutes = date.getMinutes().toString().padStart(2, "0");
            let date_obj = {
                date: formattedDate,
                time: `${hours}:${minutes}`,
                datetime: formattedDate + ` ${hours}:${minutes}`,
            };
            return date_obj;
        },
        formatLabel(option) {
            if (!option || typeof option !== "string") return "";
            const [delegation, state] = option.split(", ");
            return '<b>' + delegation + '</b>, ' + state;
        },
        isEmpty(obj) {
            for (const prop in obj) {
                if (Object.hasOwn(obj, prop)) {
                    return false;
                }
            }
            return true;
        },
        scrollTo(id) {
            const el = document.getElementById(id)
            if (el) {
                const yOffset = -173 // offset for sticky nav
                const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset
                window.scrollTo({ top: y, behavior: 'smooth' })
            }
        },
        handleScroll() {
            for (const section of this.sections) {
                const el = document.getElementById(section.id)
                if (el) {
                    const rect = el.getBoundingClientRect()
                    if (rect.top <= 180 && rect.bottom >= 180) {
                        this.activeSection = section.id
                        break
                    }
                }
            }
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll)
    },
    watch: {}
}
</script>
